module.exports = {"es-PY":{"components":{"proposal-overlay":{"info":{"title":"Detalles del proveedor"}}}}}